export default __webpack_public_path__ + "static/media/GH2.da4dc8dc.png";